import type {PublicMethodUtils} from '@wix/document-services-types'
import type {BIPublicAPI} from '@wix/document-services-public-types'
import {bi} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<BIPublicAPI> {
    return {
        methods: {
            bi: {
                event: publicMethodUtils.defineAction(bi.event, {isUpdatingData: false}),
                error: publicMethodUtils.defineAction(bi.error, {isUpdatingData: false}),
                /**
                 *
                 * @param {*} reportDefCollection map of errors by the errorName
                 * @param {string} packageName to assign the errors
                 * @param {boolean} shouldMutate - should mutate the error.reportDefCollection object?
                 * @returns {*} mutated/clone of reportDefCollection with the added properties packageName and errorName
                 */
                formatErrorEvents: publicMethodUtils.defineAction(bi.formatErrorEvents)
            }
        }
    }
}
